/** Shared `{ value, label }` enum entry shape served by the API, as it comes off the wire. */
export type AiProviderKindPayload = {
	readonly value: string;
	readonly label: string;
};

export type AiProviderKindsFetchedPayload = AiProviderKindPayload[];

export type AiProviderKindsFetchedAction = {
	type: 'AI_PROVIDER_KINDS_FETCHED';
	payload: AiProviderKindsFetchedPayload;
};

export default (payload: AiProviderKindsFetchedPayload): AiProviderKindsFetchedAction => ({
	type: 'AI_PROVIDER_KINDS_FETCHED',
	payload,
});
